import { Component, OnInit, ViewChild } from '@angular/core';
import { SimpleModalComponent } from 'ngx-simple-modal';
import { NgxSuperCroppieComponent } from 'ngx-super-croppie';
import { CroppieOptions, ResultOptions } from 'croppie';
import { Constants } from '../common/constants';
import { Toast } from '../common/toast';

export interface FileUploadInterface {
  requestObject: {};
}
@Component({
  selector: 'app-file-upload-modal',
  templateUrl: './file-upload-modal.component.html',
  styleUrls: ['./file-upload-modal.component.css']
})
export class FileUploadModalComponent extends SimpleModalComponent<FileUploadInterface, {}> implements FileUploadInterface, OnInit{
  @ViewChild('ngxSuperCroppie') ngxSuperCroppie: NgxSuperCroppieComponent;

  requestObject: any = {};
  responseObject: any = {};
  showDummyImage: boolean = true;
  enableImageCropper: boolean = false;
  showPDFFileIcon: boolean = false;
  private imageDimensionsObject: any = {};
  pdfSrc: any;
  private _uploadedFileBase64Data: string = "";

  get uploadedFileBase64Data(): string {
    return this._uploadedFileBase64Data;
  }
  set uploadedFileBase64Data(value: string) {
    this._uploadedFileBase64Data = value;
    if (value) {
      this.pdfSrc = { url: value, isEvalSupported: false };
    }
  }
  
  croppieOptions: CroppieOptions = {
    boundary: {width: 400, height: 400},
    enableExif: true,
    enableOrientation: true,
    enableZoom: true,
    enableResize: false,
    maxZoom: 0,
    minZoom: 0,
    mouseWheelZoom: true,
    showZoomer: true,
    viewport: {width: 300, height: 300, type: 'square'}
  };

  orientation = 1;
  zoom = 0.5;
  croppedImage: string | HTMLElement | Blob | HTMLCanvasElement;

  resultOptions: ResultOptions = {
    type: 'base64',
    size: {width: 600, height: 600},
    format: 'jpeg',
    quality: 1,
    circle: false,
  };

  constructor(public constants: Constants, private toast: Toast) { 
    super();
  }

  ngOnInit(){
    this.croppieOptions.enableResize = this.requestObject.isFixedCropper === this.constants.FALSE;
    this.enableImageCropper = this.requestObject.fileType !== this.constants.FILE_TYPE_PDF && this.isEmpty(this.requestObject.fileBase64Data) === false;
    this.showPDFFileIcon = this.requestObject.fileType === this.constants.FILE_TYPE_PDF && this.isEmpty(this.requestObject.fileBase64Data) === false;
    this.showDummyImage = this.enableImageCropper === false && this.showPDFFileIcon === false;
    this.uploadedFileBase64Data = this.requestObject.fileBase64Data;
  }

  confirm() {
    this.responseObject.fileType = this.responseObject.fileType === undefined || this.responseObject.fileType === this.constants.BLANK ? this.requestObject.fileType : this.responseObject.fileType;
    this.responseObject.fileBase64Data = this.responseObject.fileBase64Data === undefined || this.responseObject.fileBase64Data === this.constants.BLANK ? this.requestObject.fileBase64Data : this.responseObject.fileBase64Data;
    this.result = this.responseObject;
    this.close();
  }

  cancel() {
    this.result = {};
    this.close();
  }

  isEmpty(value:string){
    return (value == "" || value == null);
  }

  uploadFile(event: any){
    const file: File = event.target.files[0];
    const fileType = file.type;
    this.responseObject.fileType = fileType;
    if(this.requestObject.allowFileTypeList.includes(fileType) === false){
      this.toast.showErrorToast("File type "+ fileType + " is not allowed");
      return;
    }
    const reader = new FileReader();
    if(fileType === this.constants.FILE_TYPE_PDF){
      this.enableImageCropper = false;
      this.showPDFFileIcon = true;
      this.showDummyImage = false;
      reader.onloadend = this.handleReaderLoaded.bind(this);
      reader.readAsDataURL(file);
    } else {
      const imageFileSizeInBytes = file.size;
      const imageFileSizeInMB = imageFileSizeInBytes/1024/1024;
      if(imageFileSizeInMB > this.constants.USER_IMAGE_REQUIRED_SIZE_IN_MB){
        this.toast.showErrorToast("Image size should not be bigger than "+ this.constants.USER_IMAGE_REQUIRED_SIZE_IN_MB + " MB");
        return;
      }
      reader.onloadend = this.handleImageDimensionsReader.bind(this);
      reader.readAsDataURL(file);
    }
  }

  private handleReaderLoaded(event: any) {
    const reader = event.target;
    this.uploadedFileBase64Data = reader.result;
    this.responseObject.fileBase64Data = reader.result;
  }

  private fetchImageDimensions(object: any){
    return new Promise((resolve, reject) => {
      const imageDimensionsObject = {};
      const image = new Image();  
      image.src = object.target.result;
      image.onload = function(){
        imageDimensionsObject['width'] = image.width;
        imageDimensionsObject['height'] = image.height;
        resolve(imageDimensionsObject); 
      }
    });
  }
  
  private handleImageDimensionsReader(object: any) {
    this.fetchImageDimensions(object).then((response) => { 
      // const responseJSON = JSON.parse(JSON.stringify(response));
      // this.imageDimensionsObject = responseJSON;
      // if(this.requestObject.isFixedCropper === this.constants.TRUE && (responseJSON.width < this.constants.USER_IMAGE_REQUIRED_WIDTH || responseJSON.height < this.constants.USER_IMAGE_REQUIRED_HEIGHT)){
      //   this.toast.showErrorToast("Image dimensions should be more than ("+this.constants.USER_IMAGE_REQUIRED_WIDTH+"x"+this.constants.USER_IMAGE_REQUIRED_HEIGHT+")");
      //   this.showDummyImage = true;
      //   this.enableImageCropper = false;
      // } else {
        const reader = object.target;
        this.uploadedFileBase64Data = reader.result;
        this.enableImageCropper = true;
        this.showPDFFileIcon = false;
        this.showDummyImage = false;
      // }
    });
  }

  updateCroppedImage(crop: string | HTMLElement | Blob | HTMLCanvasElement): void {
    this.croppedImage = crop;
    this.responseObject.fileBase64Data = this.croppedImage;
  }

}